import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "@web-monorepo/i18next";
import { useDispatch } from "react-redux";
import ToolkitMenu from "components/ToolkitMenu";
import { setParentId } from "src/pods/parentStudents";
import { setVariant } from "src/pods/variant";
import { showNativeNav } from "src/pods/webviewInit";
import { logParentToolkitEvent } from "src/utils/logEvent";

function Index() {
  const [params] = useSearchParams();
  const query = Object.fromEntries(params.entries());

  const isPremiumUnlocked = query.isPremiumUnlocked == "true";
  const variant = query.variant || "off";
  const parentId = query.parentId;

  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.beyond"]);
  const dispatch = useDispatch();

  useEffect(() => {
    logParentToolkitEvent({ eventName: `webview.viewed` });

    showNativeNav(true);
    return () => {
      showNativeNav(false);
    };
  });

  useEffect(() => {
    if (parentId) {
      dispatch(setParentId(parentId));
    }
    dispatch(setVariant(variant.toString().split(",")));
  }, [dispatch, parentId, variant]);

  if (!ready) return null;
  return <ToolkitMenu {...{ isPremiumUnlocked, variant }} />;
}

export default Index;
